import React from 'react';
import TranslationStatuses from '../../../../model/TranslationStatuses';
import useEnumerableModel from '../../../data/hooks/useEnumerableModel';
import itemIdValue from '../../../itemIdValue';
import useLabel from '../../utils/Translations/useLabel';
import MultiselectFilter from './MultiselectFilter';
const TranslationStatusSelector = ({ title, ...props }) => {
    const _title = useLabel('Status', title);
    const { options } = useEnumerableModel(TranslationStatuses);
    return (<MultiselectFilter itemId={itemIdValue} options={options} title={_title} {...props}/>);
};
export default TranslationStatusSelector;
